import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTRBIIssueCouponThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTRBIIssueCouponThenSendMacroNode/DTRBIIssueCouponThenSendMacroNode';

const RbiIssueCouponThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTRBIIssueCouponThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'The coupon has been issued.'}
    />
  );
};

export default RbiIssueCouponThenSendMacro;
